import makeService from './api';

export default makeService('profile_parameter_set_values');
